import { FC } from 'react'
import { Box } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'

export const AccordionIcon: FC = () => {
  return <Box
    width="36px"
    height="36px"
    display="flex"
    alignItems="center"
    justifyContent="center"
    sx={{
      borderRadius:'5px',
      border: (theme) => `1px solid ${theme.palette.grey[300]}`
    }}
  >
    <ExpandMore sx={{ color: 'secondary.main' }} />
  </Box>
}